import { EINVOICE_STATUS } from '@/utils/einvoice.enum'
import { buildAdjustmentDraftPdfViewerConfig } from '@/view/pages/einvoice/adjustment/utils/adjustmentPdfViewer.utils'
import { resolveLifecycleActionAllowance } from './lifecycleState.utils'

const EINVOICE_FETCH_PDF = 'einvoice/fetchPdf'

// Trạng thái nháp/tiền phát hành: PDF trong modal là bản xem trước đã tải sẵn.
// Cho phép tải xuống chính bản xem trước này (không cần keySearch của hóa đơn đã phát hành).
// Khớp với tập "draft-like" trong inferPdfEndpoint — các trạng thái lấy PDF qua preview endpoint.
const PREVIEW_DOWNLOADABLE_STATUSES = Object.freeze([
  EINVOICE_STATUS.DRAFT, // nháp
  EINVOICE_STATUS.READY_TO_ISSUE, // sẵn sàng phát hành (vẫn là bản nháp)
  EINVOICE_STATUS.ISSUE_FAILED, // phát hành lỗi (còn bản nháp để tải)
])

// Trạng thái đã phát hành: tải PDF gốc do CQT cấp
const ISSUED_DOWNLOADABLE_STATUSES = Object.freeze([
  EINVOICE_STATUS.ISSUED,
  EINVOICE_STATUS.TAX_ACCEPTED,
  EINVOICE_STATUS.ADJUSTED,
  EINVOICE_STATUS.REPLACED,
])

function looksLikeAdjustmentDraftRow(obj) {
  const dc = obj?.draftCode
  return typeof dc === 'string' && /^ADJ-/i.test(dc.trim())
}

function canDownloadPdf(invoice = {}) {
  // Bản xem trước của nháp luôn cho phép tải xuống, kể cả khi backend
  // chưa mở action "download-pdf" trong allowedActions.
  if (PREVIEW_DOWNLOADABLE_STATUSES.includes(invoice.status)) {
    return true
  }

  const fromLifecycle = resolveLifecycleActionAllowance(invoice, 'download-pdf')
  if (fromLifecycle !== null) {
    return fromLifecycle
  }

  return ISSUED_DOWNLOADABLE_STATUSES.includes(invoice.status)
}

export function buildEInvoicePdfViewerConfig(store, invoice = {}) {
  if (looksLikeAdjustmentDraftRow(invoice)) {
    return buildAdjustmentDraftPdfViewerConfig(invoice)
  }

  const invoiceKey = invoice.invoiceNo || invoice.id || 'document'
  const title = invoice.invoiceNo
    ? `Xem PDF hóa đơn ${invoice.invoiceNo}`
    : `Xem PDF hóa đơn ${invoice.saleInvoiceCode || invoice.id || ''}`.trim()
  const allowedToDownload = canDownloadPdf(invoice)

  return {
    title: title || 'Xem PDF hóa đơn',
    downloadName: `HDDT_${invoiceKey}.pdf`,
    canDownload: allowedToDownload,
    canPrint: allowedToDownload,
    eventContext: {
      invoiceId: invoice.id || null,
      salesInvoiceId: invoice.salesInvoiceId || null,
      saleType: invoice.saleType || null,
      invoiceNo: invoice.invoiceNo || null,
    },
    loadPdf() {
      return store.dispatch(EINVOICE_FETCH_PDF, invoice)
    },
  }
}
